import React from "react";
import { Navigate } from "react-router-dom";
import { getDecryptedUserFromCookie } from "./utils/getCookie";

/**
 * Admission UI is only for Skates category admins (or SuperAdmin).
 * Sidebar rule unchanged; this blocks direct URL access for other admins.
 */
function isSkatesCategory(value) {
    const n = String(value ?? "")
        .trim()
        .toLowerCase()
        .replace(/\s+/g, " ");
    return n === "skates" || n.includes("skates");
}

function SkatesAdmissionRoute({ children }) {
    const user = getDecryptedUserFromCookie();
    if (!user?.main_id) {
        return <Navigate to="/login" replace />;
    }
    const allowed = user.type === "SuperAdmin" || isSkatesCategory(user.category);
    if (!allowed) {
        return <Navigate to="/" replace />;
    }
    return children;
}

export default SkatesAdmissionRoute;
